<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { handleNext } from '../tutorialSteps'
import { useRouter } from 'vue-router'

const playerFlagsStore = usePlayerFlagsStore()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_first_contact_end', router)
  await playerFlagsStore.setFlag('tutorial_complete', 'true')
}
</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/government.webm"
  >
    <template #text>
      <p class="pb-2">
        Excellent work!
      </p>
      <p class="pb-2">
        You've successfully made first contact with another civilization and learned the basics of diplomacy and communication.
      </p>
      <p class="pb-2">
        Remember, relationships you build now will shape your empire's future. Choose your allies wisely, communicate effectively, and always be prepared for both friendship and conflict.
      </p>
    </template>

    <template #alerts>

    </template>

    <template #buttons>
      <ActionButton @click="handleNextStep">
        Thank you!
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>